import { io } from 'socket.io-client';
import { LocalStorageService } from '@/shared/services/localStorage.service';
import { ChatSocketClient } from './chatSocketClient';

let instance: ChatSocketClient | null = null;

export function getChatSocketClient(): ChatSocketClient {
  if (!instance) {
    const apiOrigin = import.meta.env.VITE_API_URL_BASE;
    if (!apiOrigin) {
      throw new Error('VITE_API_URL_BASE is required for ChatSocketClient');
    }

    instance = new ChatSocketClient({
      apiOrigin,
      getAccessToken: () => LocalStorageService.getAccessToken(),
      ioFactory: io,
    });
  }
  return instance;
}

export function destroyChatSocketClient(): void {
  instance?.disconnect();
  instance = null;
}
